var map = {
	"./EnglishData.txt": 7105,
	"./FaunaMendocina/EnglishData.txt": 3054,
	"./FaunaMendocina/SpanishData.txt": 5161,
	"./FaunaMendocina/faunaMendocina1.png": 3473,
	"./FaunaMendocina/faunaMendocina2.png": 4163,
	"./FaunaMendocina/faunaMendocina3.png": 6296,
	"./FaunaMendocina/faunaMendocina4.png": 9913,
	"./FaunaMendocina/faunaMendocina5.png": 9881,
	"./FaunaMendocina/fuanaMendocina0.png": 7337,
	"./FaunaStore/EnglishData.txt": 4457,
	"./FaunaStore/SpanishData.txt": 6106,
	"./FaunaStore/faunaStore0.png": 9504,
	"./FaunaStore/faunaStore1.png": 6722,
	"./FaunaStore/faunaStore2.png": 1052,
	"./FaunaStore/faunaStore3.png": 4029,
	"./FaunaStore/faunaStore4.png": 3633,
	"./FaunaStore/faunaStore5.png": 3970,
	"./FaunaStore/faunaStore6.png": 1082,
	"./GameLand/EnglishData.txt": 3000,
	"./GameLand/SpanishData.txt": 7012,
	"./GameLand/gameLand0.png": 2937,
	"./GameLand/gameLand1.png": 7417,
	"./GameLand/gameLand2.png": 2282,
	"./GameLand/gameLand3.png": 5946,
	"./GameLand/gameLand4.png": 3355,
	"./GameLand/gameLand5.png": 8505,
	"./GameLand/gameLand6.png": 4086,
	"./Hola.docx": 9271,
	"./Minesweeper/EnglishData.txt": 5343,
	"./Minesweeper/SpanishData.txt": 123,
	"./Minesweeper/minesweeper0.png": 1280,
	"./Minesweeper/minesweeper1.png": 6027,
	"./Minesweeper/minesweeper2.png": 7566,
	"./Minesweeper/minesweeper3.png": 489,
	"./Portfolio/EnglishData.txt": 2749,
	"./Portfolio/SpanishData.txt": 5226,
	"./Portfolio/portfolio0.png": 8340,
	"./Portfolio/portfolio1.png": 3880,
	"./Portfolio/portfolio2.png": 5887,
	"./Portfolio/portfolio3.png": 1685,
	"./Portfolio/portfolio4.png": 1539,
	"./Portfolio/portfolio5.png": 3,
	"./Portfolio/portfolio6.png": 8728,
	"./SomosVenezolanos/EnglishData.txt": 2704,
	"./SomosVenezolanos/SpanishData.txt": 8467,
	"./SomosVenezolanos/somosVenezolanos0.png": 7702,
	"./SomosVenezolanos/somosVenezolanos1.png": 4027,
	"./SomosVenezolanos/somosVenezolanos2.png": 6767,
	"./SomosVenezolanos/somosVenezolanos3.png": 3877,
	"./SomosVenezolanos/somosVenezolanos4.png": 4943,
	"./SomosVenezolanos/somosVenezolanos5.png": 6279,
	"./SomosVenezolanos/somosVenezolanos6.png": 6298,
	"./SpanishData.txt": 8305,
	"./Tic_tac_toe/EnglishData.txt": 137,
	"./Tic_tac_toe/SpanishData.txt": 1751,
	"./Tic_tac_toe/tic_tac_toe0.png": 9418,
	"./Tic_tac_toe/tic_tac_toe1.png": 8338,
	"./Tic_tac_toe/tic_tac_toe2.png": 3586,
	"./Tic_tac_toe/tic_tac_toe3.png": 8008,
	"./background.png": 8462,
	"./email.png": 1959,
	"./fondo.png": 355,
	"./github.png": 1061,
	"./google.png": 5100,
	"./linkedin.png": 1477,
	"./photo.png": 8962,
	"./whatsapp.png": 7700,
	"./white-background-with-blue-tech-hexagon/19366.jpg": 3092,
	"./white-background-with-blue-tech-hexagon/License free.txt": 3525,
	"./white-background-with-blue-tech-hexagon/License premium.txt": 6477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;